// extracted by mini-css-extract-plugin
export default {"quotePanel":"finance_symbol-detail-table_quotePanel","wide":"finance_symbol-detail-table_wide"};